export default "__VITE_ASSET__C1A2$d_G__"